/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Skill_Groups_Create_NameInputs */

const en_forms_skill_groups_create_name = /** @type {(inputs: Forms_Skill_Groups_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_forms_skill_groups_create_name = /** @type {(inputs: Forms_Skill_Groups_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Forms_Skill_Groups_Create_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_skill_groups_create_name = /** @type {((inputs?: Forms_Skill_Groups_Create_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Skill_Groups_Create_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_skill_groups_create_name(inputs)
	return de_forms_skill_groups_create_name(inputs)
});